(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["seline-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seline-bundle-offer')) {
    class SelineBundleOffer extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        const ids = JSON.parse(this.querySelector('[data-variants]').textContent);
        const prices = JSON.parse(this.querySelector('[data-prices]').textContent);
        this.priceById = {};
        ids.forEach((id, i) => (this.priceById[String(id)] = prices[i]));
        this.fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

        this.addEventListener('change', (e) => {
          if (e.target.matches('.seline-bundle__radio')) this.applyQty();
        });

        // Garante a quantidade correta no envio (Comprar agora / Yampi)
        this._onSubmit = (e) => {
          if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) this.applyQty();
        };
        this._onClick = (e) => {
          const btn = e.target.closest && e.target.closest('button[type="submit"], [name="add"]');
          if (btn && this.section.contains(btn)) this.applyQty();
        };
        document.addEventListener('submit', this._onSubmit, true);
        document.addEventListener('click', this._onClick, true);

        // Observa troca de variante e re-renderizações do formulário
        this._observer = new MutationObserver(() => this.sync());
        this._observer.observe(this.section, {
          subtree: true, childList: true, attributes: true, attributeFilter: ['value'],
        });
        this.section.addEventListener('change', () => setTimeout(() => this.sync(), 50));

        this.sync();
      }
      disconnectedCallback() {
        document.removeEventListener('submit', this._onSubmit, true);
        document.removeEventListener('click', this._onClick, true);
        this._observer && this._observer.disconnect();
      }
      get qty() {
        const r = this.querySelector('.seline-bundle__radio:checked');
        return r ? parseInt(r.value, 10) : 1;
      }
      forms() {
        return this.section.querySelectorAll('form[action*="/cart/add"]');
      }
      applyQty() {
        const q = String(this.qty);
        this.forms().forEach((form) => {
          let input = form.querySelector('input[name="quantity"]') ||
            (form.id && document.querySelector(`input[name="quantity"][form="${form.id}"]`));
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            form.appendChild(input);
          }
          if (input.value !== q) {
            input.value = q;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        this.section.querySelectorAll('input[name="quantity"]').forEach((i) => {
          if (i.value !== q) i.value = q;
        });
      }
      sync() {
        if (this._syncing) return;
        this._syncing = true;
        const idInput = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
        const price = idInput && this.priceById[String(idInput.value)];
        if (price != null && price !== this._price) {
          this._price = price;
          this.querySelectorAll('.seline-bundle__card').forEach((card) => {
            const q = +card.dataset.qty, pct = +card.dataset.pct;
            const full = price * q;
            const compare = card.querySelector('[data-compare]');
            if (compare) compare.textContent = this.fmt.format(full / 100);
            card.querySelector('[data-final]').textContent =
              this.fmt.format(Math.round((full * (100 - pct)) / 100) / 100);
          });
        }
        this.applyQty();
        this._syncing = false;
      }
    }
    customElements.define('seline-bundle-offer', SelineBundleOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
